import { Icon } from '@whinerp/ui';
import { useSession } from '../app/session.js';
import { useT } from '../app/i18n.js';

/**
 * This workspace is a sandbox (G-287). On every screen and not dismissible:
 * the point is that nobody tries a rule here believing it is live, or changes
 * production believing it is the sandbox.
 */
export function WorkspaceSandboxBanner(): JSX.Element | null {
  const t = useT();
  const { session } = useSession();
  if (!session.workspace.isSandbox) return null;
  return (
    <div data-region="workspace-sandbox" role="status" className="flex items-center gap-2 border-b border-b-rule bg-info-tint px-gutter py-1 text-dense text-ink">
      <Icon name="Info" size="inline" decorative />
      <span>{t('wsSandbox.banner', { values: { name: session.workspace.name } })}</span>
    </div>
  );
}
